import { statementStatusMeta } from "../../constants/statementStatus";

// Same status symbols as the Invoice Statements page (see StatusPill); the strip just
// pairs each symbol with its count. `unreconciled` can be negative (credits net against
// debits), so show its magnitude.
const money = (n) =>
   new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(Math.abs(n || 0));

export default function SummaryStrip({ counts }) {
   const c = counts || { unmatched: 0, partial: 0, matched: 0, unreconciled: 0 };
   const item = (statusKey, label, value) => {
      const m = statementStatusMeta(statusKey);
      const Icon = m.icon;
      return (
         <span style={{ display: "inline-flex", alignItems: "center", gap: 6, marginRight: 20 }}>
            <Icon color={m.color} size={16} />
            <span style={{ fontWeight: 600 }}>{value}</span>
            <span className="text-secondary">{label}</span>
         </span>
      );
   };
   return (
      <div className="d-flex align-items-center flex-wrap mb-3" style={{ fontSize: 14 }}>
         {item("pending", "unmatched", c.unmatched)}
         {item("partial", "partial", c.partial)}
         {item("reconciled", "matched", c.matched)}
         <span className="text-secondary" style={{ marginLeft: "auto" }}>
            {money(c.unreconciled)} unreconciled
         </span>
      </div>
   );
}
